import {
  REQUEST_CASE_EXPORT_TYPES,
  RECEIVE_CASE_EXPORT_TYPES,
  ERROR_CASE_EXPORT_TYPES,
} from "typeConstants";
import { exportTypes as initialState } from "reducers/initialState.tsx";

const exportTypes = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASE_EXPORT_TYPES:
      return {
        ...state,
        exportTypeResults: [],
        fetchingExportTypes: true,
      };
    case RECEIVE_CASE_EXPORT_TYPES:
      return {
        ...state,
        exportTypeResults: action.payload,
        fetchingExportTypes: false,
      };
    case ERROR_CASE_EXPORT_TYPES:
      return {
        ...state,
        exportTypeResults: [],
        fetchingExportTypes: false,
      };
    default:
      return state;
  }
};

export default exportTypes;
